import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import cx from 'classnames';

import LOGO_IMG from 'assets/logo/logo_black.svg';
import LOGO_IMG_SM from 'assets/logo/logo.svg';
import { pathSlugToPageName } from 'utils';
import { isAuthenticatedSelector } from 'store/user/selectors';
import HeaderLinks from './HeaderLinks';

import './header.scss';

function Header(props) {
  const [sidebarExists, setSidebarExists] = useState(false);
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const customer = useSelector((state) => state.customers.currentCustomer);

  useEffect(
    () => () => {
      document.documentElement.classList.remove('nav-open');
    },
    [],
  );

  const mobileSidebarToggle = (e) => {
    if (!sidebarExists) {
      setSidebarExists(true);
    }
    e.preventDefault();
    document.documentElement.classList.toggle('nav-open');
    const navbarCollapseElement = document.createElement('div');
    navbarCollapseElement.id = 'bodyClick';
    navbarCollapseElement.onclick = () => {
      navbarCollapseElement.parentElement.removeChild(navbarCollapseElement);
      document.documentElement.classList.toggle('nav-open');
      const wrapper = document.getElementById('root').getElementsByClassName('wrapper')[0];
      wrapper.style.overflow = 'auto';
      const navbarElement = document.getElementsByClassName('navbar-collapse collapse in');
      if (navbarElement.length) {
        navbarElement[0].classList.toggle('in');
      }
    };
    document.body.appendChild(navbarCollapseElement);
    const wrapper = document.getElementById('root').getElementsByClassName('wrapper')[0];
    wrapper.style.overflow = 'hidden';
  };

  const renderLogo = () => {
    if (!customer || !customer.uuid) {
      return <div className="logo" />;
    }

    return (
      <div className="logo">
        <a href="/" className="simple-text logo-normal full-width">
          <div className="logo-img">
            {customer.logo ? (
              <img src={customer.logo} className="customer-logo" alt="logo_image" />
            ) : (
              <>
                <img src={LOGO_IMG} className="bigLogo" alt="logo_image" />
                <img src={LOGO_IMG_SM} className="smallLogo" alt="logo_image" />
              </>
            )}
          </div>
        </a>
      </div>
    );
  };

  const { location, dashboardHeader, ecosystemHeader, brandText, showCollapse } = props;

  if (dashboardHeader) {
    const pageNameFromSlug = pathSlugToPageName(location.pathname);
    return (
      <div className="dashboard-navbar">
        <Box component="nav" className="navbar navbar-default navbar-fixed-top">
          <Box className="container-fluid">
            <Box className="navbar-header">
              <button type="button" className="navbar-toggle" onClick={mobileSidebarToggle}>
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <Box className="navbar-brand">
                <Typography sx={{ fontSize: '1.5rem' }} data-testid={`page_name-${pageNameFromSlug.slug}`}>
                  {pageNameFromSlug.pageName}
                </Typography>
              </Box>
            </Box>
            <Box className="navbar-collapse collapse">
              <HeaderLinks showCommit />
            </Box>
          </Box>
        </Box>
      </div>
    );
  }

  if (ecosystemHeader) {
    return (
      <div className="ecosystems__navbar">
        {renderLogo()}
        <div className="main-panel">
          <Box component="nav" className="navbar navbar-default">
            <Box className="container-fluid">
              <Box className="navbar-header">
                <Box className="navbar-brand">
                  <div>{brandText}</div>
                </Box>
                <Box className="navbar-brand ecosystem_dashboard">
                  <div className="active">Summary</div>
                </Box>
              </Box>
              {showCollapse && isAuthenticated && (
                <Box className="navbar-collapse collapse">
                  <HeaderLinks />
                </Box>
              )}
            </Box>
          </Box>
        </div>
      </div>
    );
  }

  return (
    <div className="ecosystems__navbar">
      {renderLogo()}
      <div className="main-panel">
        <Box component="nav" className="navbar navbar-default">
          <Box className="container-fluid">
            <Box className="navbar-header">
              <Box className="navbar-brand">
                <div className={cx({ active: brandText })}>{brandText}</div>
              </Box>
            </Box>
            {showCollapse && isAuthenticated && (
              <Box className="navbar-collapse collapse">
                <HeaderLinks />
              </Box>
            )}
          </Box>
        </Box>
      </div>
    </div>
  );
}

Header.propTypes = {
  brandText: PropTypes.string,
  showCollapse: PropTypes.bool,
  dashboardHeader: PropTypes.bool,
  ecosystemHeader: PropTypes.bool,
  location: PropTypes.object,
};

Header.defaultProps = {
  showCollapse: true,
  dashboardHeader: false,
};

export default Header;
